export function WorkspaceSettings(){
  return (
    <section data-testid="settings-workspace" className="space-y-3">
      <h2 className="font-medium">Workspace</h2>
      <p className="text-sm text-gray-500">
        Workspace-level settings will be available in a future release.
      </p>
    </section>
  );
}
